import { useEffect } from 'react';
import { Link, type ErrorComponentProps } from '@tanstack/react-router';
import Logo from '../ui/logo';

const linkBase = 'inline-flex h-9 items-center rounded-lg px-4 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';

/** The video workspace's error screen: a crash inside the studio leaves the logo, a way back and Reload, not the router's blank default. */
export function WorkspaceCrash({ error }: ErrorComponentProps) {
  useEffect(() => {
    console.error('[studio] the video workspace crashed:', error);
  }, [error]);
  return (
    <main role="alert" className="flex min-h-full flex-col bg-background px-4 py-6 text-foreground sm:px-8">
      <Link to="/" search={{ slide: undefined }} aria-label="4K Labs home" className="self-start">
        <Logo variant="compact" />
      </Link>
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center gap-3 pb-16">
        <h1 className="text-2xl font-semibold tracking-tight">The studio stopped drawing this page</h1>
        <p className="text-[15px] leading-6 text-muted-foreground">Your video is safe. Reloading the page usually fixes this.</p>
        <div className="mt-2 flex flex-wrap gap-2">
          <button type="button" onClick={() => window.location.reload()} className={`${linkBase} bg-primary text-primary-foreground hover:bg-primary/90`}>
            Reload
          </button>
          <Link to="/videos" className={`${linkBase} border border-border hover:bg-muted`}>
            Your videos
          </Link>
        </div>
      </div>
    </main>
  );
}
